import React, { useEffect, useState } from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'

// images
import hero from "./images/hero.svg";
import callicon from "./images/callicon.svg";
import mailicon from "./images/mailicon.svg";
import locationicon from "./images/locationicon.svg";

// icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";

import Getintouch from './Getintouch';
import axios from 'axios';
interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}

interface datastructure{
 
  value:string,
  id:number,
  name:String,
}


const ContactUs = () => {
  const[bannerdata, setBannerdata] = useState<banner[]>([]);
  const[pagedata, setPagedata] = useState<datastructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/contactdata",{
            
      });

        console.log('contactdata data',response.data)
        setPagedata(response.data);
        console.log("contactdata data in a array",pagedata);
      } catch (error) {
        console.error("contactdata Not Found:", error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/contactbanner",{
            
      });

        console.log('banner data',response.data)
        setBannerdata(response.data);
        console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("banner Not Found:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <div>
   <Header/>
   {bannerdata.map((items)=>(
 <div
 className="w-full h-[451px] relative"
 style={{
  backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${items.image.replace(/\\/g, '/')})`,
   backgroundPosition: "center",
   backgroundSize: "cover",
 }}
>
 {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
 <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
   <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
  {items.title}
   </h2>
   <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
   {items.content}
   </p>
   <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
     <a
       className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
       href="/"
     >
       {" "}
       <FaHome />
       Home
     </a>
     <a
       className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
       href="/contactus"
     >
       {" "}
       <IoIosArrowForward />
       Contact Us            </a>
   
   </div>
 </div>
</div>
   ))}
  

{/* we are here */}

<div className='bg-[#101729] py-14 px-[8%]'>
  <h2 className='text-[#F1F4F9] text-[39px] font-semibold'>We are Here for You</h2>
<div className='flex flex-wrap w-[100%] gap-y-5 justify-between mt-5'>
  {pagedata.filter((items)=>items.name === 'number').map((items)=>(
    <div className="bg-[#1E2A3A]  p-10 flex flex-col items-center md:w-[32%] w-[100%] rounded-[16px]">
          <img className="w-[72px] h-[72px]" src={callicon} alt="" />
         <a href={`tel:${items.value}`}> <h2 className="text-[#CBD5E0] text-[18px] font-semibold mt-5">{items.value}</h2></a>
          </div>
  ))}

 {pagedata.filter((items)=>items.name === 'email').map((items)=>(
          <div className="bg-[#1E2A3A]  p-10 flex flex-col items-center md:w-[32%] w-[100%] rounded-[16px]">
          <img className="w-[72px] h-[72px]" src={mailicon} alt="" />
          <a href={`mailto:${items.value}`}> <h2 className="text-[#CBD5E0] text-[18px] font-semibold mt-5">{items.value}</h2></a>
          </div>
))}

{pagedata.filter((items)=>items.name === 'address').map((items)=>(
          <div className="bg-[#1E2A3A]  p-10 flex flex-col items-center md:w-[32%] w-[100%] rounded-[16px]">
          <img className="w-[72px] h-[72px]" src={locationicon} alt="" />
          <h2 className="text-[#CBD5E0] text-[18px] font-semibold mt-5 text-center">{items.value}</h2>
          </div>
))}

          
</div>
</div>

      {/* get in touch */}
      <Getintouch/>
   
   <Footer/>

    </div>
  )
}

export default ContactUs